import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageSlotModule } from '@spartacus/storefront';
import { ConfigModule, I18nModule, provideDefaultConfig } from '@spartacus/core';
import { PrimengModule } from '../primeng/primeng.module';
import { FormsModule } from '@angular/forms';
import { SGRESharedModule } from '../../SGRE-shared/SGRE-shared.module';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { HttpBackend } from '@angular/common/http';

import { customDefaultOccCartConfig } from './config/default-occ-cart-config';

import { CustomRouteGuard } from '../../SGRE-shared/services/guard/msal.guard';

import { CartService } from './services/cart.service';
import { CartTrackingService } from './services/cart-tracking.service';
import { CartEffectsService } from './store/Effects/cart-effect.service';

import { CartComponent } from './components/cart/cart.component';
import { CartProceedCheckoutComponent } from './components/cart-proceed-checkout/cart-proceed-checkout.component';
import { CartCsvPdfComponent } from './components/cart-csv-pdf/cart-csv-pdf.component';
import { RecreateModalPopupComponent } from './components/recreate-modal-popup/recreate-modal-popup.component';
import { CartPageReducer } from './store/Reducer/CartPage.reducer';
import { CartPageEffects } from './store/Effects/cart.effect';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CART_PAGE_DETAILS } from './models/custom-cart.model';
import { CartApplyCustomerCouponComponent } from './components/cart-apply-customer-coupon/cart-apply-customer-coupon.component';

export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, ['/public/i18n/core/', '/public/i18n/vendors/']);
}

@NgModule({
  declarations: [
    CartComponent,
    CartProceedCheckoutComponent,
    CartCsvPdfComponent,
    RecreateModalPopupComponent,
    CartApplyCustomerCouponComponent
  ],
  imports: [
    CommonModule,
    PageSlotModule,
    PrimengModule,
    StoreModule.forFeature(CART_PAGE_DETAILS, CartPageReducer),
    EffectsModule.forFeature(CartPageEffects),
    FormsModule,
    SGRESharedModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CartComponent: {
          component: () => import('./components/cart/cart.component').then(m => m.CartComponent),
          guards: [CustomRouteGuard],
        },
        CSVAndPDFExportComponent: {
          component: () => import('./components/cart-csv-pdf/cart-csv-pdf.component').then(m => m.CartCsvPdfComponent),
          guards: [CustomRouteGuard],
        },
        CartProceedToCheckoutComponent: {
          component: () => import('./components/cart-proceed-checkout/cart-proceed-checkout.component').then(m => m.CartProceedCheckoutComponent),
          guards: [CustomRouteGuard],
        },
        CartApplyCustomerCouponComponent: {
          component: () => import('./components/cart-apply-customer-coupon/cart-apply-customer-coupon.component').then(m => m.CartApplyCustomerCouponComponent),
          guards: [CustomRouteGuard],
        }
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    I18nModule,
  ],
  providers: [
    TranslateService,
    { provide: TranslateStore },
    provideDefaultConfig(customDefaultOccCartConfig),
    CartService,
    CartTrackingService,
    CartEffectsService,
  ]
})
export class CartModule { }